import { z } from 'zod';
import { LocalizedStringSchema } from './studio';

export const MenuCatalogDataBindingSchema = z.object({
  kind: z.literal('menu_catalog'),
  catalogId: z.string().uuid(),
  display: z.enum(['grid', 'tabs']).default('grid'),
  hideUnavailable: z.boolean().default(true),
  /**
   * Curated subset from the same Menu Book catalog.
   * - omit → full catalog (Menu page, or bar drinks-only)
   * - `[]` / UUIDs → Home highlight, or Weinkarte when a food Speisekarte exists
   */
  itemIds: z.array(z.string().uuid()).optional(),
  /** Menu page drops Weinkarte rows that the drinks block already projects. */
  excludeItemIds: z.array(z.string().uuid()).optional(),
});

export const FloorPlanDataBindingSchema = z.object({
  kind: z.literal('floor_plan'),
  planId: z.string().uuid(),
  showCapacity: z.boolean().default(true),
});

export const FormDataBindingSchema = z.object({
  kind: z.literal('form'),
  formKey: z.string().min(1),
});

export const DataBindingSchema = z.discriminatedUnion('kind', [
  MenuCatalogDataBindingSchema,
  FloorPlanDataBindingSchema,
  FormDataBindingSchema,
]);

export type DataBinding = z.infer<typeof DataBindingSchema>;
export type MenuCatalogDataBinding = z.infer<typeof MenuCatalogDataBindingSchema>;
